import React from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../shared/components/UIElements/Icon';
import Logo from '../../shared/components/UIElements/Logo';
import './Users.css';
const roles = [
  {
    id: 'doctor',
    number: '01',
    title: 'Doctor',
    description: 'More time for your patients.',
    features: [
      'Find patients & view their history',
      'Create and check prescriptions',
      'Keep notes & track vitals'
    ],
    action: 'Continue as doctor'
  },
  {
    id: 'patient',
    number: '02',
    title: 'Patient',
    description: 'Your health, all in one place.',
    features: [
      'Access your medical history',
      'Upload & view health reports',
      'Keep your health profile up to date'
    ],
    action: 'Continue as patient'
  },
  {
    id: 'pharmacy',
    number: '03',
    title: 'Pharmacy',
    description: 'Stay connected to patient care.',
    features: [
      'View incoming prescriptions',
      'Manage medication refill alerts',
      'Review inventory insights'
    ],
    action: 'Continue as pharmacy'
  }
];
const Users = () => (
  <div className="user-selection">
    <div className="welcome-heading">
      <p className="eyebrow">
        <span className="status-dot" /> YOUR CONNECTED CARE WORKSPACE
      </p>
      <h1>
        Good care starts
        <br />
        with <span>better connections.</span>
      </h1>
      <p>
        One place for doctors, patients, and pharmacies.
        <br className="desktop-break" /> Choose your role to get started.
      </p>
    </div>
    <div className="role-grid">
      {roles.map((role) => (
        <Link className={`role-card role-card--${role.id}`} key={role.id} to={`/auth/${role.id}`}>
          <div className="role-card__top">
            <span className="role-icon">
              <Icon name={role.id} size={30} />
            </span>
            <span className="role-number">{role.number}</span>
          </div>
          <h2>{role.title}</h2>
          <p className="role-description">{role.description}</p>
          <ul>
            {role.features.map((feature) => (
              <li key={feature}>
                <Icon name="check" size={16} />
                {feature}
              </li>
            ))}
          </ul>
          <div className="role-card__action">
            {role.action}
            <Icon name="arrow" />
          </div>
        </Link>
      ))}
    </div>
    <div className="welcome-footer">
      <Logo className="welcome-footer__logo" />
      <p>Care, connected.</p>
      <span>Doctors · Patients · Pharmacies</span>
    </div>
  </div>
);
export default Users;
